import './BreadOrderCard.css';
import breadService from '../../../services/breadorders.service';

export default function BreadOrderCard({ order }) {

    function getCorrectDateFormat(dateISOString) {
        const dateParts = dateISOString.split('T')[0].split('-'); // ['2025', '05', '09']
        const localDate = new Date(Number(dateParts[0]), Number(dateParts[1]) - 1, Number(dateParts[2]));
        const options = { weekday: 'long', month: 'long', day: 'numeric' };
        return localDate.toLocaleDateString('es-MX', options);
    }

    function StatusButton() {
        if (order.status === 'pending') {
            return <button onClick={() => handleStatusChange()} className='bread-order-card-status-button ready-button'>Markar Listo</button>;
        }
        if (order.status === 'baked') {
            return <button onClick={() => handleStatusChange()} className='bread-order-card-status-button pending-button'>Markar Pendiente</button>;
        }
        if (order.status === 'completed') {
            return (
                <div className='order-ready'>📦 ORDEN EMPACADA 📦</div>
            )
        } else {
            return <button onClick={() => handleStatusChange()} className='bread-order-card-status-button ready-button'>Markar Listo</button>;
        }
    }

    function handleStatusChange() {
        if (order.status === 'pending') {
            breadService.updateOrderStatus(order.id, 'baked');
        } else if (order.status === 'baked') {
            breadService.updateOrderStatus(order.id, 'pending');
        } else {
            breadService.updateOrderStatus(order.id, 'baked');

        }
    }

    return (
        <div className='bread-order-card'>
            <div className='bread-order-card-customer-name'>{order.firstName} {order.lastName}</div>
            <div className='bread-order-card-details'>
                <label>Fecha:</label>
                <span>{getCorrectDateFormat(order.date)}</span>
            </div>
            <div className='bread-order-card-details'>
                <label>Hora:</label>
                <span>{order.time}</span>
            </div>
            <div className='bread-order-card-details'>
                <label>Panes</label>
                <div className='bread-order-card-bread-container'>
                {order.bread.map((item, index) => (
                    <div key={index} className='bread-order-card-bread'>
                        <span>{item.quantity} {item.bread}</span>

                    </div>
                ))}
                </div>
            
            </div>

            {order.comments && (
                <div className='bread-order-card-details'>
                    <label>Comentarios:</label>
                    <span>{order.comments}</span>
                </div>
            )}
            <StatusButton />
            
        </div>
    );
}